import { Controller } from "@hotwired/stimulus"

const loaded_event = new Event("DOMContentLoaded", { bubbles: true });
export default class extends Controller {
  static targets = ["entries", "pagination"]
  static values = {
    scrollSelector: { type: String, default: null }
  }

  initialize() {
    this.loading = false // prevent multiple calls to loadMore when this.loading is undefined
  }

  connect() {
    const scrollContainer = this.scrollSelectorValue
      ? document.querySelector(this.scrollSelectorValue)
      : null

    this.scrollingElement = scrollContainer || window
    this.scrollHandler = this.scroll.bind(this)
    this.scrollingElement.addEventListener("scroll", this.scrollHandler)
  }

  scroll() {
    if (!this.hasPaginationTarget) { return }
    let next_page = this.paginationTarget.querySelector("a[rel='next']")
    if (next_page == null) { return }

    let url = next_page.href

    const { scrollTop, clientHeight, scrollHeight } = this.scrollMetrics()
    const bottomScrollPosition = scrollTop + clientHeight
    const triggerPoint = scrollHeight - 400

    if (bottomScrollPosition >= triggerPoint) {
      this.loadMore(url)
    }
  }

  loadMore(url) {
    if (this.loading) { return }
    this.loading = true

    this.showSpinner();

    fetch(url, {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => response.json())
      .then((data) => {
        this.entriesTarget.insertAdjacentHTML('beforeend', data.entries);
        this.paginationTarget.innerHTML = data.pagination;
        this.loading = false;
        this.hideSpinner();
        document.dispatchEvent(loaded_event);
      })
  }

  showSpinner() {
    this.entriesTarget.insertAdjacentHTML('afterend', `
      <div class="row justify-content-center">
        <div id="spinner" class="my-5 spinner-grow text-primary" role="status"><span class="sr-only">Loading...</span></div>
      </div>
    `)
  }

  hideSpinner() {
    document.getElementById('spinner').remove()
  }

  scrollMetrics() {
    if (this.scrollingElement === window) {
      const doc = document.documentElement
      return {
        scrollTop: window.pageYOffset || doc.scrollTop,
        clientHeight: window.innerHeight,
        scrollHeight: doc.scrollHeight
      }
    }

    return {
      scrollTop: this.scrollingElement.scrollTop,
      clientHeight: this.scrollingElement.clientHeight,
      scrollHeight: this.scrollingElement.scrollHeight
    }
  }
}
